import { Api } from 'vopay';
import { ReactNode, createContext } from 'react';

export type ApiProviderProps = {
  api: Api;
  children: ReactNode;
};

export const ApiContext = createContext<Api | null>(null);
